import React, { useState } from 'react';
import { Container, Button, Modal, ProgressBar } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const QuoteForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);



  // Remplacez par l'URL de votre Google Form
  const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLScTzegEOHmCFsMbUVeFBaAKNMyn6LO1sfKtfH3tvaXaEK20XQ/viewform?embedded=true";
  
  // URL après soumission (optionnel)
  const formResponseUrl = "https://docs.google.com/forms/d/e/YOUR_FORM_ID/formResponse";

  const handleOpenForm = () => {
    setShowModal(true);
    setLoading(true);
    // Simulation de progression
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setLoading(false);
          return 100;
        }
        return prev + 10;
      });
    }, 300);
  };

  const handleClose = () => {
    setShowModal(false);
    setFormSubmitted(false);
    setProgress(0);
  };

  const handleSubmit = () => {
    // Cette fonction est déclenchée par le message postMessage depuis l'iframe
    setFormSubmitted(true);
  };

  // Écouteur pour la soumission du formulaire
  React.useEffect(() => {
    const receiveMessage = (event) => {
      if (event.origin !== "https://docs.google.com") return;
      if (event.data.includes("formSubmitted")) {
        handleSubmit();
      }
    };

    window.addEventListener("message", receiveMessage);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);

  return (
    <Container className="my-5">
      <h2 className="mb-4">Demande de devis gratuit</h2>
      <p className="lead"> Remplissez ce formulaire pour recevoir une analyse personnalisée de vos besoins</p>
      
      <Button 
        variant="primary" 
        size="lg"
        onClick={handleOpenForm}
      >
        Accéder au Formulaire
      </Button>

      <Modal 
        show={showModal} 
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Formulaire de demande de devis</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ minHeight: '500px' }}>
          {loading && (
            <div className="text-center my-5">
              <ProgressBar now={progress} label={`${progress}%`} />
              <p className="mt-2">Chargement du formulaire...</p>
            </div>
          )}
          
          {!loading && !formSubmitted && (
            
            <iframe
              src={googleFormUrl}
              width="100%" 
              height="500"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Google Form"
              onLoad={() => setLoading(false)}
            >
              Chargement en cours...
            </iframe>
          )}
          
          {formSubmitted && (
            <div className="text-center py-4">
              <div className="alert alert-success">
                <h4>Merci pour votre soumission!</h4>
                <p>Votre formulaire a été validé avec succès.</p>
              </div>
              <Button variant="success" onClick={handleClose}>
                Fermer et Continuer
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <small className="text-muted">
            En soumettant ce formulaire, vous acceptez nos conditions d'utilisation.
          </small>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default QuoteForm;